module.exports = __webpack_public_path__ + "static/media/suit.e33f0277.svg";